import { useHistory } from "react-router-dom";
import { useRef, useState } from "react";
import { AxiosResponse } from "axios";
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ModelOfCartao } from '../../database/index';

import { useAuth } from "src/contexts/auth";
import api from '../../services/api';

export const useFormCreateCartao = () => {
    const { userAgencyId } = useAuth();
    const [loading, setLoading] = useState<boolean>(false);
    const [cartaoResponse, setCartaoResponse] = useState<AxiosResponse | null>(null);
    const [cartaoEditedResponse, setCartaoEditedResponse] = useState<AxiosResponse | null>(null);
    const history = useHistory();

    const toast: any = useRef();

    const validationSchema = Yup.object().shape({
        DESCRICAO: Yup.string().required('* Campo Obrigatório'),
        IDENTIFICACAO: Yup.string().required('* Campo Obrigatório'),
        CURINGA: Yup.number(),
        STATUS: Yup.number(),
    });

    const saveCartao = async (cartao: ModelOfCartao) => {
        setLoading(true);

        const newCartao: ModelOfCartao = {
            ...cartao,
            ORGAO: userAgencyId
        }
        console.log("passando pela gravaçao dos cartaos")
        if (!!cartaoResponse) {
            console.log("passando pela gravaçao dos cartaos 1111: ",cartaoResponse.data)
            api.put(`cartaos/${cartaoResponse.data.ID}`, newCartao)
                .then((response) => {
                    formik.resetForm();
                    setCartaoEditedResponse(response);
                    setCartaoResponse(null);
                    setLoading(false);
                    toast.current.show({ severity: 'success', summary: 'Edição realizada', detail: 'A cartao foi editada com sucesso!', life: 5000 });
                }).catch((err) => {
                    console.log(err);
                    setLoading(false);
                    toast.current.show({ severity: 'error', summary: 'Edição não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
                })
        } else {
            console.log("newCartao: ",newCartao)
            api.post('cartaos', newCartao)
                .then((response) => {
                    
                    if (window.location.href === '/cartaoForm') history.push('/listCartaos');
                    setLoading(false);
                    setCartaoResponse(response);
                    toast.current.show({ severity: 'success', summary: 'Cadastro realizado', detail: 'Operação realizada com sucesso!', life: 5000 });
                }).catch((err) => {
                    console.log("response: ",err)
                    setLoading(false);
                    toast.current.show({ severity: 'error', summary: 'Cadastro não realizado', detail: 'Falha ao realizar operação!', life: 5000 });
                });
        }
    }

    const formik = useFormik<ModelOfCartao>({
        initialValues: {
            ORGAO: '',
            DESCRICAO: '',
            IDENTIFICACAO: '',
            CURINGA: 1,
            STATUS: 0,
        },
        onSubmit: async values => await saveCartao(values),
        validationSchema
    });

    return {
        getCartaoFormController: {
            formik,
            loading,
            toast,
            cartaoResponse,
            cartaoEditedResponse
        },
        handleCartaoFormController: {
            setCartaoResponse,
            setCartaoEditedResponse
        }
    };
};
